// extracted by mini-css-extract-plugin
module.exports = {"tab":"a10a3f92e9--tab--1isfE","active":"a10a3f92e9--active--3CD3u"};